export default __webpack_public_path__ + "static/media/tools.ecbdcef2.jpg";